import { render, staticRenderFns } from "./JsonEdit.vue?vue&type=template&id=af2a27f6&scoped=true&"
import script from "./JsonEdit.vue?vue&type=script&lang=ts&"
export * from "./JsonEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2a27f6",
  null
  
)

export default component.exports